import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import GigCard from '@/partials/GigCards/GigCard/GigCard.vue'

const GIGS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    GigCard,
    InfiniteLoading,
  },
  data() {
    return {
      anchor: '#gig-cards',
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState('myGigs', {
      isLoading: (state: any) => state.freelancerPostedList.isLoading,
      isLoaded: (state: any) => state.freelancerPostedList.isLoaded,
      pagination: (state: any) => state.freelancerPostedList.pagination,
      gigs: (state: any) => state.freelancerPostedList.values,
    }),
  },
  async created() {
    await this.load({ limit: GIGS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myGigs/getFreelancerPostedGigsList',
      loadMore: 'myGigs/loadMoreFreelancerPostedGigsList',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.gigs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: GIGS_LIMIT, offset: this.gigs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Gigs - Posted'),
    }
  },
})
